import {getMethod} from '~/api'

async function get(contentProviderId, request, cancelToken) {
    return await getMethod(`/api/contentProviders/${contentProviderId}/locations`, request, cancelToken)
}

export {get}
